module.exports = __webpack_public_path__ + "img/logo-app.a3f6a205.png";